<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Add Activities

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="modal-body padding-top-0px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-8px">Activity Description</label>
                      </div>

                      <div class="col-md-8">
                        <textarea class="form-control3 size-2 width-inherit" rows="2"
                                   name="CurrentSaveIvfPlanActivityTemplateRequest.ActivityDescription"
                                        [(ngModel)]="CurrentSaveIvfPlanActivityTemplateRequest.ActivityDescription" required minlength="1" maxlength="100"
                                        #addconcerns_text="ngModel"></textarea>
                              <small class="form-text text-danger"
                                     *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>


                      </div>
                    </div>


                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-8px">Applicable To</label>
                      </div>

                      <div class="col-md-6">
                        <CodeTypeValue CodeType="IACTO"
                                       id="CurrentSaveIvfPlanActivityTemplateRequest.ApplicableTo"
                                       [(ngModel)]="CurrentSaveIvfPlanActivityTemplateRequest.ApplicableTo" SelectedValue=""
                                       name="CurrentSaveIvfPlanTemplateRequest.ApplicableTo" required>
                        </CodeTypeValue>
                        

                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-8px">Type</label>
                      </div>

                      <div class="col-md-6">
                        <CodeTypeValue CodeType="ISUBA"
                                       id="CurrentSaveIvfPlanActivityTemplateRequest.ActivityType"
                                       [(ngModel)]="CurrentSaveIvfPlanActivityTemplateRequest.ActivityType" SelectedValue=""
                                       name="CurrentSaveIvfPlanTemplateRequest.ActivityType" required>
                        </CodeTypeValue>
                        


                      </div>
                    </div>


                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-8px">SVC</label>
                      </div>

                      <div class="col-md-6">

                        <input type="text" class="form-control form-control-patient"
                               id="CurrentSaveIvfPlanActivityTemplateRequest.ServiceCode" placeholder="ServiceCode"
                               [(ngModel)]="CurrentSaveIvfPlanActivityTemplateRequest.ServiceCode"
                               name="CurrentSaveIvfPlanActivityTemplateRequest.ServiceCode">

                      </div>
                      <div class="col-md-2">
                        <button class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3 padding-top-1px padding-bottom-1px padding-left-6 padding-right-6px" type="button">
                          <i class="fa fa-ellipsis-h fa-w-16 nav-link-hand color-Assign"></i>
                          
                        </button>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-8px">DOC</label>
                      </div>

                      <div class="col-md-6">
                        <input type="text" class="form-control form-control-patient"
                               id="CurrentSaveIvfPlanActivityTemplateRequest.DOC" placeholder="DOC"
                               [(ngModel)]="CurrentSaveIvfPlanActivityTemplateRequest.DOC"
                               name="CurrentSaveIvfPlanActivityTemplateRequest.DOC">


                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-8px">Seq</label>
                      </div>

                      <div class="col-md-6">
                        <input type="number" class="form-control form-control-patient"
                               id="CurrentSaveIvfPlanActivityTemplateRequest.SeqNo" placeholder="SeqNo"
                               [(ngModel)]="CurrentSaveIvfPlanActivityTemplateRequest.SeqNo"
                               name="CurrentSaveIvfPlanActivityTemplateRequest.SeqNo">


                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>


            <!--<div class="card-footer text-align-center">
              <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Close</button>
            </div>-->


















          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
